export default {
    BASE_URL: 'crm/stats/contrast',
    api: [
        {
            name: 'synchronousData',
            desc: '同步数据',
            method: 'GET',
            path: '/synchronousData'
        },
        {
            name: 'teamDetails',
            desc: '项目在场班组详情',
            method: 'GET',
            path: '/teamDetails'
        },
        {
            name: 'projectDetails',
            desc: '项目详情',
            method: 'GET',
            path: '/projectDetails'
        },
        {
            name: 'selectProjectList',
            desc: '项目对比分析数据列表',
            method: 'GET',
            path: '/selectProjectList'
        },
        {
            name: 'exportData',
            desc: '项目对比分析数据列表',
            method: 'GET',
            path: '/export'
        }
    ]
}


// WEBPACK FOOTER //
// ./src/api/statistics/proj-compare.js